import { ExtendedSubscriptionInterval } from './extended-subscription-interval';
import { OneTimePurchaseKind } from './one-time-purchase-kind';
import { SubscriptionKind } from './subscription-kind';

export type LicenseKind = OneTimePurchaseKind | SubscriptionKind<ExtendedSubscriptionInterval> | { type: 'FREE' };
